import React, { FC, useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Column, Editing, FilterPanel, FilterRow, HeaderFilter } from 'devextreme-react/data-grid';

import moment from 'moment';

import { AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { useAuth } from 'context/auth';
import { Button, CheckBox, DataGrid, DateBox, Template } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import {
  useChangeOperatingScheduleListMutation,
  useLazyGetOperatingScheduleReportQuery,
} from 'bus/operatingSchedule/services/services';

const EmployeesReportWork: FC = () => {
  const { getClaims }: any = useAuth();
  const [data, setData] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [date, setDate] = useState<any>(moment().startOf('month').format('YYYY-MM-DD[T]HH:mm:ss.SSS'));

  const [changeOperatingScheduleList, { isLoading: isLoadingChange }] = useChangeOperatingScheduleListMutation();
  const [getOperatingScheduleReport] = useLazyGetOperatingScheduleReportQuery();

  const dataSource = useCallback(async () => {
    const currentDate = moment(date).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    const dataLoad: any = await $createStore(`/v1/OperatingSchedule?date=${currentDate}`, 'id').load();
    setData(dataLoad);

    if (dataLoad.length) {
      setColumns(Object.keys(dataLoad[0].schedule));
    }
  }, [date]);

  useEffect(() => {
    dataSource();
  }, [dataSource, date]);

  const saveChange = async () => {
    if (!data?.length) {
      return;
    }

    const tempData = {
      date: moment(date).format('YYYY-MM-DD[T]HH:mm:ss.SSS'),
      info: data.map((d) => ({
        id: d.id,
        schedules: d.schedule,
      })),
    };
    changeOperatingScheduleList(tempData);

    toast.success('Изменения успешно сохранены', {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  };

  const getReport = async () => {
    const currentDate = moment(date).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    getOperatingScheduleReport({ date: currentDate });
  };

  /* const statusEditorRender = (cell) => {
    return (
      <CheckBox
        defaultValue={cell.value}
        readOnly={!getClaims(['CanEditOperatingSchedule'])}
        onValueChange={(e) => {
          cell.setValue(e);
        }}
      />
    );
  }; */

  return (
    <div className="container-dev" style={{ maxWidth: 'calc(100vw - 350px)' }}>
      <AppLayoutTop title="График смен">
        <div className="d-flex">
          <DateBox
            stylingMode="underlined"
            type="date"
            onValueChange={setDate}
            useMaskBehavior
            dateSerializationFormat="yyyy-MM-dd"
            displayFormat="MM-yyyy"
            value={date}
            calendarOptions={{
              maxZoomLevel: 'year',
              minZoomLevel: 'century',
            }}
          />
          <ClaimsProvider claimsBlock={['CanEditOperatingSchedule']}>
            <Button text="Сохранить" className="ml-2" type="default" onClick={saveChange} disabled={isLoadingChange} />
          </ClaimsProvider>
        </div>
      </AppLayoutTop>

      <div style={{ overflowX: 'scroll' }}>
        <DataGrid
          dataSource={data}
          keyExpr="id"
          defaultColumns={columns}
          showBorders={true}
          onToolbarPreparing={(e) => {
            e.toolbarOptions?.items?.unshift({
              location: 'after',
              template: 'excel',
            });
          }}
        >
          <Template name="excel">
            <ClaimsProvider claimsBlock={['CanCreateOperatingScheduleReport']}>
              <Button icon="export" onClick={getReport} text="" hint="Отчет" />
            </ClaimsProvider>
          </Template>

          <Column dataField="post" caption="Должность" allowEditing={false} width={200} />
          <Column dataField="name" caption="ФИО" allowEditing={false} width={200} />
          {columns.map((date) => (
            <Column
              dataField={`schedule.${date}`}
              caption={date}
              key={date}
              width={50}
              allowFiltering={false}
              allowSorting={false}
              allowEditing={getClaims(['CanEditOperatingSchedule'])}
              //editCellRender={statusEditorRender}
            />
          ))}
          <Editing mode="cell" allowUpdating={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
        </DataGrid>
      </div>
    </div>
  );
};

export default EmployeesReportWork;
